import { render, staticRenderFns } from "./ApproveReview.vue?vue&type=template&id=17f1695c&"
import script from "./ApproveReview.vue?vue&type=script&lang=js&"
export * from "./ApproveReview.vue?vue&type=script&lang=js&"
import style0 from "./ApproveReview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports